import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50da12a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SupplyList" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "filter" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "请先选择品种", -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "topTag" }
const _hoisted_8 = { class: "item-img" }
const _hoisted_9 = {
  key: 1,
  class: "vip"
}
const _hoisted_10 = {
  key: 0,
  class: "left"
}
const _hoisted_11 = {
  key: 1,
  class: "left"
}
const _hoisted_12 = { class: "right" }
const _hoisted_13 = { class: "top" }
const _hoisted_14 = {
  key: 0,
  class: "bottom sliver"
}
const _hoisted_15 = {
  key: 1,
  class: "bottom gold"
}
const _hoisted_16 = {
  key: 2,
  class: "bottom crown"
}
const _hoisted_17 = {
  key: 3,
  class: "split"
}
const _hoisted_18 = { class: "item-info" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "text" }
const _hoisted_21 = { class: "time" }
const _hoisted_22 = { class: "quantityWarpper" }
const _hoisted_23 = {
  key: 0,
  class: "quantity"
}
const _hoisted_24 = {
  key: 1,
  class: "quantity"
}
const _hoisted_25 = {
  key: 2,
  class: "quantity"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "电议", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "isBond" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("已缴纳保证金")
const _hoisted_31 = { class: "tags" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("实名认证")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("企业认证")
const _hoisted_34 = { class: "address" }
const _hoisted_35 = { class: "add" }
const _hoisted_36 = { class: "distance" }
const _hoisted_37 = {
  key: 0,
  class: "notify"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "您正在找相关供应 是否补充采购需求，让供应商主动报价", -1))
const _hoisted_39 = { class: "btn" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("去发布")
const _hoisted_41 = { class: "close" }
const _hoisted_42 = { class: "notFollow" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "苗搭档", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "找苗、卖苗快人一步 为了匹配更好的求购处理 请关注公众号", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "长安二维码识别关注", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanSearch = _resolveComponent("VanSearch")!
  const _component_VanDropdownItem = _resolveComponent("VanDropdownItem")!
  const _component_VanEmpty = _resolveComponent("VanEmpty")!
  const _component_VanDropdownMenu = _resolveComponent("VanDropdownMenu")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_VanTag = _resolveComponent("VanTag")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_VanSearch, {
        placeholder: "请输入关键字",
        modelValue: $setup.getListData.keyword,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.getListData.keyword) = $event)),
        "show-action": "",
        shape: "round",
        onFocus: _cache[1] || (_cache[1] = ($event: any) => {$setup.isShowSearch=true;})
      }, {
        action: _withCtx(() => [
          _createElementVNode("div", {
            class: "text",
            onClick: $setup.reset
          }, "取消")
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_VanDropdownMenu, {
        "active-color": "#07c160",
        "z-index": "2002"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VanDropdownItem, {
            title: "地区",
            ref: "areaMenu"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["CityTreeSelector"], {
                modelValue: $setup.getListData.areaId,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.getListData.areaId) = $event)),
                onConfirm: $setup.setAreaId
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_VanDropdownItem, {
            title: $setup.filterCategoryName || '品种',
            ref: "categoryMenu"
          }, {
            default: _withCtx(() => [
              _createVNode($setup["VarietiesTreeSelector"], { onConfirm: $setup.setCategoryId })
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_VanDropdownItem, {
            options: $setup.comprehensive,
            modelValue: $setup.comprehensiveValue,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.comprehensiveValue) = $event)),
            onChange: $setup.setSort
          }, null, 8, ["modelValue"]),
          _createVNode(_component_VanDropdownItem, { title: "筛选" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_VanEmpty, { image: "error" }, {
                description: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 512), [
                [_vShow, !$setup.getListData.categoryId]
              ]),
              ($setup.getListData.categoryId)
                ? (_openBlock(), _createBlock($setup["Specifications"], {
                    key: 0,
                    id: $setup.getListData.categoryId,
                    onConfirm: $setup.confirmSpecifications
                  }, null, 8, ["id"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_VanList, {
      class: "list",
      listLoading: $setup.loading,
      "onUpdate:listLoading": _cache[4] || (_cache[4] = ($event: any) => (($setup.loading) = $event)),
      onLoad: $setup.getList,
      "immediate-check": false,
      finished: $setup.finished,
      "finished-text": "没有更多了"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
          return (_openBlock(), _createBlock($setup["ListItemAd"], {
            key: `supply${index}`,
            data: index%5 == 0?$setup.addList[index/5]:{}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "list-item",
                onClick: ($event: any) => ($setup.router.push({name:"SupplyDetail",query:{id:item.id}}))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_VanImage, {
                      src: require("@/assets/img/supply_top_tag.png")
                    }, null, 8, ["src"])
                  ], 512), [
                    [_vShow, item.supplyTop]
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_VanImage, {
                      src: item.photos?item.photos[0]:"",
                      radius: "4",
                      style: {"width":"100%","height":"100%"}
                    }, null, 8, ["src"]),
                    (item.video.length)
                      ? (_openBlock(), _createBlock(_component_VanIcon, {
                          key: 0,
                          class: "play",
                          name: "play-circle-o",
                          size: "40",
                          color: "#FFF"
                        }))
                      : _createCommentVNode("", true),
                    (item.userCertification.vipRank > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (item.supplyTop)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_VanImage, {
                                  src: require("@/assets/img/list/tui.png"),
                                  width: "100%",
                                  height: "100%"
                                }, null, 8, ["src"])
                              ])),
                          _createElementVNode("span", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              (item.userCertification.vipRank==3)
                                ? (_openBlock(), _createBlock(_component_VanImage, {
                                    key: 0,
                                    src: require("@/assets/img/list/s.png"),
                                    width: "100%",
                                    height: "100%"
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true),
                              (item.userCertification.vipRank==6)
                                ? (_openBlock(), _createBlock(_component_VanImage, {
                                    key: 1,
                                    src: require("@/assets/img/list/h.png"),
                                    width: "100%",
                                    height: "100%"
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true),
                              (item.userCertification.vipRank==7)
                                ? (_openBlock(), _createBlock(_component_VanImage, {
                                    key: 2,
                                    src: require("@/assets/img/list/w.png"),
                                    width: "100%",
                                    height: "100%"
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true)
                            ]),
                            (item.userCertification.vipRank==3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.information.year) + "年", 1))
                              : (item.userCertification.vipRank==6)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.information.year) + "年", 1))
                                : (item.userCertification.vipRank==7)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.information.year) + "年", 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_17, " "))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_21, _toDisplayString($setup.time2Stamp(item.refreshTime)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      (item.price)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("span", null, _toDisplayString(item.price.toFixed(2)), 1),
                            _createElementVNode("span", null, "元/ " + _toDisplayString(item.unit), 1)
                          ]))
                        : (item.minPrice)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("span", null, _toDisplayString(item.minPrice.toFixed(2)), 1),
                              _createElementVNode("span", null, "元/ " + _toDisplayString(item.unit), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27)),
                      _createElementVNode("div", {
                        class: "similar",
                        onClick: _withModifiers(($event: any) => {$setup.getListData.keyword = item.categoryName;$setup.search()}, ["stop"])
                      }, "类似供应", 8, _hoisted_28)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _withDirectives(_createVNode(_component_VanTag, {
                        size: "small",
                        plain: "",
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30
                        ]),
                        _: 2
                      }, 1536), [
                        [_vShow, item.userCertification.reassureRank]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode($setup["VipTag"], {
                        type: item.userCertification.vipRank,
                        year: item.year
                      }, null, 8, ["type", "year"]),
                      _withDirectives(_createVNode(_component_VanTag, {
                        size: "small",
                        plain: "",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_32
                        ]),
                        _: 2
                      }, 1536), [
                        [_vShow, item.userCertification.hasIdCard]
                      ]),
                      _withDirectives(_createVNode(_component_VanTag, {
                        size: "small",
                        plain: "",
                        color: "#6775D2"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_33
                        ]),
                        _: 2
                      }, 1536), [
                        [_vShow, item.userCertification.hasBusinessLicense]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(item.address), 1),
                      _createElementVNode("div", _hoisted_36, _toDisplayString($setup.distance(item.location)), 1)
                    ])
                  ])
                ])
              ], 8, _hoisted_5)
            ]),
            _: 2
          }, 1032, ["data"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["listLoading", "onLoad", "finished"]),
    ($setup.showregister)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_VanButton, {
              round: "",
              block: "",
              size: "small",
              type: "success",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({name:"ReleaseWantToBuy"})))
            }, {
              default: _withCtx(() => [
                _hoisted_40
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_VanImage, {
              src: require("@/assets/img/close.png"),
              width: "20",
              height: "20",
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.close()))
            }, null, 8, ["src"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode($setup["SearchCategorie"], {
      modelValue: $setup.isShowSearch,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.isShowSearch) = $event)),
      keyword: $setup.getListData.keyword,
      "onUpdate:keyword": _cache[8] || (_cache[8] = ($event: any) => (($setup.getListData.keyword) = $event)),
      onSelected: $setup.searchList,
      "hot-type": "supply"
    }, null, 8, ["modelValue", "keyword"]),
    _createVNode(_component_VanPopup, {
      show: $setup.isNotFollow,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => (($setup.isNotFollow) = $event)),
      style: {"width":"80vw","border-radius":"4px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _hoisted_44,
          _createVNode(_component_VanImage, {
            src: "https://mdd-static.oss-cn-hangzhou.aliyuncs.com/wechat/gzh.jpg",
            style: {"width":"100%"},
            radius: "4"
          }),
          _hoisted_45
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}